import { useContext } from 'react'
import { useFlag } from '@sketch/modules-common'
import { ShareWithoutVersion } from 'modules/versioning'
import { VersionFragment, useGetWorkspaceQuery } from '@sketch/gql-types'
import { ModalContext } from '@sketch/components'
import ShareSettingsModal, {
  ShareMinimalForSettingsModal,
} from 'modules/shares/modals/ShareSettingsModal'
import SharingModal from 'modules/shares/modals/SharingModal'

interface ShareWithWorkspace extends ShareWithoutVersion {
  workspace: any
}

export const useSharingModal = (
  share: ShareMinimalForSettingsModal,
  latestVersion: VersionFragment,
  workspaceId: string
) => {
  const { showModal } = useContext(ModalContext)
  const isNewSharingOn = useFlag('new-sharing')

  // get workspace data for the new modal
  const { data, loading } = useGetWorkspaceQuery({
    variables: { identifier: workspaceId },
    skip: !isNewSharingOn || 'workspace' in share,
  })

  const openShareSettingsModal = (options?: {
    closeOnRouteChange: boolean
  }) => {
    if (isNewSharingOn) {
      if (loading) {
        return
      }

      const shareWithWorkspace = {
        ...share,
        workspace: data?.workspace,
      } as ShareWithWorkspace

      showModal(SharingModal, {
        share: shareWithWorkspace,
        latestVersion,
      })

      return
    }
    showModal(ShareSettingsModal, { share }, options)
  }

  return { openShareSettingsModal }
}
